// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nl1V1v {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
  width: 100%;
  height: 100%;
  padding: var(--spacing-3);
}

.FVQ_Xj {
  margin-bottom: var(--spacing-1);
}

.teUosP {
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  background: var(--surface-neutral-white);
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.08);
  border-radius: var(--radius-s);
  overflow: hidden;
}

.euahif {
  width: 100%;
  padding: var(--spacing-3);
  border-bottom: 1px solid var(--stroke-neutral-subtle);
}

.LaI0As {
  font-family: var(--font-family-base);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-stronger);
  margin: 0;
}

.y5jMEB {
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: var(--spacing-3);
}

.avyOXK {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  color: var(--text-neutral-stronger);
  margin: 0 0 var(--spacing-3) 0;
}

.e1bWQa {
  margin-bottom: var(--spacing-2);
}

.ERk_b6 {
  display: flex;
  gap: var(--spacing-2);
  justify-content: flex-end;
  margin-top: auto;
}

/* Buttons */
.TofuWI,
.uKNnvK {
  height: 40px;
  padding: 0 var(--spacing-4);
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  border-radius: var(--radius-s);
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 100px;
  border: 2px solid;
}

.TofuWI {
  background-color: transparent;
  border-color: var(--brand-tr-orange);
  color: var(--brand-tr-orange);
}

.TofuWI:hover:not(:disabled) {
  background-color: rgba(211, 47, 47, 0.04);
}

.uKNnvK {
  background-color: var(--brand-tr-orange);
  color: var(--surface-neutral-white);
  border-color: var(--brand-tr-orange);
}

.uKNnvK:hover:not(:disabled) {
  background-color: var(--brand-tr-orange-dark, #b71c1c);
  border-color: var(--brand-tr-orange-dark, #b71c1c);
}

.uKNnvK:disabled {
  background-color: var(--surface-neutral-soft, #e0e0e0);
  border-color: var(--surface-neutral-soft, #e0e0e0);
  color: var(--text-neutral-strong, #9e9e9e);
  cursor: not-allowed;
}

.TofuWI:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Error State */
.erwY3x {
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: var(--background-alt);
  border: 2px solid var(--stroke-primary-medium);
  border-radius: var(--radius-s);
  padding: var(--spacing-6);
  min-height: 500px;
}

.oKtrSw {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-2);
  text-align: center;
  height: 100%;
}

.qrB34F {
  width: 72px;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--surface-neutral-white);
  border: 2px dashed var(--stroke-primary-medium);
  border-radius: 50%;
  margin-bottom: var(--spacing-1);
}

.FBHhrQ {
  width: 72px;
  height: 72px;
  color: var(--brand-tr-orange);
}

.wpbQE1 {
  width: 72px;
  height: 72px;
  color: var(--success-medium, #4caf50);
}

.cKZmH2 {
  font-family: var(--font-family-base);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-stronger);
  margin: 0;
  margin-top: var(--spacing-2);
}

.E7qXw9 {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  color: var(--text-neutral-strong);
  margin: 0;
  margin-top: var(--spacing-1);
  line-height: 1.5;
}

.czXiXt {
  display: flex;
  gap: var(--spacing-2);
  justify-content: center;
  margin-top: var(--spacing-5);
}

/* Loading State */
.Yg0djX {
  width: 48px !important;
  height: 48px !important;
  color: var(--brand-tr-orange) !important;
  animation: wTc2l8 1s linear infinite;
}

@keyframes wTc2l8 {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Responsive */
@media (max-width: 768px) {
  .nl1V1v {
    padding: var(--spacing-2);
    gap: var(--spacing-2);
  }

  .euahif {
    padding: var(--spacing-2);
  }

  .y5jMEB {
    padding: var(--spacing-2);
  }

  .LaI0As {
    font-size: var(--font-size-md);
  }

  .avyOXK {
    font-size: var(--font-size-sm);
  }

  .e1bWQa {
    max-width: 100%;
  }

  .ERk_b6 {
    flex-direction: column;
    gap: var(--spacing-1-5);
  }

  .TofuWI,
  .uKNnvK {
    width: 100%;
  }

  .erwY3x {
    padding: var(--spacing-4);
    min-height: 400px;
  }

  .oKtrSw {
    gap: var(--spacing-1-5);
  }

  .qrB34F {
    width: 56px;
    height: 56px;
  }

  .FBHhrQ {
    width: 28px;
    height: 28px;
  }

  .cKZmH2 {
    font-size: var(--font-size-md);
  }

  .E7qXw9 {
    font-size: var(--font-size-sm);
  }

  .czXiXt {
    flex-direction: column;
    width: 100%;
    margin-top: var(--spacing-3);
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/conta-pj/src/pages/IncomeReport/IncomeReport.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,OAAO;EACP,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,wCAAwC;EACxC,2CAA2C;EAC3C,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qDAAqD;AACvD;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,mCAAmC;EACnC,SAAS;AACX;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,YAAY;AACZ;;EAEE,YAAY;EACZ,2BAA2B;EAC3B,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,8BAA8B;EAC9B,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;EACxC,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,sDAAsD;EACtD,kDAAkD;AACpD;;AAEA;EACE,sDAAsD;EACtD,kDAAkD;EAClD,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,OAAO;EACP,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,8CAA8C;EAC9C,8BAA8B;EAC9B,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;EACxC,+CAA+C;EAC/C,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,mCAAmC;EACnC,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,iCAAiC;EACjC,SAAS;EACT,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA,kBAAkB;AAClB;EACE,sBAAsB;EACtB,uBAAuB;EACvB,wCAAwC;EACxC,oCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,eAAe;AACf;EACE;IACE,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,4BAA4B;EAC9B;AACF","sourcesContent":[".main {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3);\n  width: 100%;\n  height: 100%;\n  padding: var(--spacing-3);\n}\n\n.breadcrumbContainer {\n  margin-bottom: var(--spacing-1);\n}\n\n.section {\n  flex: 1;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  background: var(--surface-neutral-white);\n  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.08);\n  border-radius: var(--radius-s);\n  overflow: hidden;\n}\n\n.header {\n  width: 100%;\n  padding: var(--spacing-3);\n  border-bottom: 1px solid var(--stroke-neutral-subtle);\n}\n\n.title {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-stronger);\n  margin: 0;\n}\n\n.body {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding: var(--spacing-3);\n}\n\n.subtitle {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  color: var(--text-neutral-stronger);\n  margin: 0 0 var(--spacing-3) 0;\n}\n\n.formSection {\n  margin-bottom: var(--spacing-2);\n}\n\n.actions {\n  display: flex;\n  gap: var(--spacing-2);\n  justify-content: flex-end;\n  margin-top: auto;\n}\n\n/* Buttons */\n.buttonOutline,\n.buttonPrimary {\n  height: 40px;\n  padding: 0 var(--spacing-4);\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  border-radius: var(--radius-s);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 100px;\n  border: 2px solid;\n}\n\n.buttonOutline {\n  background-color: transparent;\n  border-color: var(--brand-tr-orange);\n  color: var(--brand-tr-orange);\n}\n\n.buttonOutline:hover:not(:disabled) {\n  background-color: rgba(211, 47, 47, 0.04);\n}\n\n.buttonPrimary {\n  background-color: var(--brand-tr-orange);\n  color: var(--surface-neutral-white);\n  border-color: var(--brand-tr-orange);\n}\n\n.buttonPrimary:hover:not(:disabled) {\n  background-color: var(--brand-tr-orange-dark, #b71c1c);\n  border-color: var(--brand-tr-orange-dark, #b71c1c);\n}\n\n.buttonPrimary:disabled {\n  background-color: var(--surface-neutral-soft, #e0e0e0);\n  border-color: var(--surface-neutral-soft, #e0e0e0);\n  color: var(--text-neutral-strong, #9e9e9e);\n  cursor: not-allowed;\n}\n\n.buttonOutline:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Error State */\n.errorSection {\n  flex: 1;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background: var(--background-alt);\n  border: 2px solid var(--stroke-primary-medium);\n  border-radius: var(--radius-s);\n  padding: var(--spacing-6);\n  min-height: 500px;\n}\n\n.errorContent {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: var(--spacing-2);\n  text-align: center;\n  height: 100%;\n}\n\n.errorIconContainer {\n  width: 72px;\n  height: 72px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--surface-neutral-white);\n  border: 2px dashed var(--stroke-primary-medium);\n  border-radius: 50%;\n  margin-bottom: var(--spacing-1);\n}\n\n.errorIcon {\n  width: 72px;\n  height: 72px;\n  color: var(--brand-tr-orange);\n}\n\n.successIcon {\n  width: 72px;\n  height: 72px;\n  color: var(--success-medium, #4caf50);\n}\n\n.errorTitle {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-stronger);\n  margin: 0;\n  margin-top: var(--spacing-2);\n}\n\n.errorMessage {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  color: var(--text-neutral-strong);\n  margin: 0;\n  margin-top: var(--spacing-1);\n  line-height: 1.5;\n}\n\n.errorActions {\n  display: flex;\n  gap: var(--spacing-2);\n  justify-content: center;\n  margin-top: var(--spacing-5);\n}\n\n/* Loading State */\n.loadingIcon {\n  width: 48px !important;\n  height: 48px !important;\n  color: var(--brand-tr-orange) !important;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .main {\n    padding: var(--spacing-2);\n    gap: var(--spacing-2);\n  }\n\n  .header {\n    padding: var(--spacing-2);\n  }\n\n  .body {\n    padding: var(--spacing-2);\n  }\n\n  .title {\n    font-size: var(--font-size-md);\n  }\n\n  .subtitle {\n    font-size: var(--font-size-sm);\n  }\n\n  .formSection {\n    max-width: 100%;\n  }\n\n  .actions {\n    flex-direction: column;\n    gap: var(--spacing-1-5);\n  }\n\n  .buttonOutline,\n  .buttonPrimary {\n    width: 100%;\n  }\n\n  .errorSection {\n    padding: var(--spacing-4);\n    min-height: 400px;\n  }\n\n  .errorContent {\n    gap: var(--spacing-1-5);\n  }\n\n  .errorIconContainer {\n    width: 56px;\n    height: 56px;\n  }\n\n  .errorIcon {\n    width: 28px;\n    height: 28px;\n  }\n\n  .errorTitle {\n    font-size: var(--font-size-md);\n  }\n\n  .errorMessage {\n    font-size: var(--font-size-sm);\n  }\n\n  .errorActions {\n    flex-direction: column;\n    width: 100%;\n    margin-top: var(--spacing-3);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `nl1V1v`,
	"breadcrumbContainer": `FVQ_Xj`,
	"section": `teUosP`,
	"header": `euahif`,
	"title": `LaI0As`,
	"body": `y5jMEB`,
	"subtitle": `avyOXK`,
	"formSection": `e1bWQa`,
	"actions": `ERk_b6`,
	"buttonOutline": `TofuWI`,
	"buttonPrimary": `uKNnvK`,
	"errorSection": `erwY3x`,
	"errorContent": `oKtrSw`,
	"errorIconContainer": `qrB34F`,
	"errorIcon": `FBHhrQ`,
	"successIcon": `wpbQE1`,
	"errorTitle": `cKZmH2`,
	"errorMessage": `E7qXw9`,
	"errorActions": `czXiXt`,
	"loadingIcon": `Yg0djX`,
	"spin": `wTc2l8`
};
module.exports = ___CSS_LOADER_EXPORT___;
